import { createContext } from 'react';

export type FlexibleInfoCtx = {
  showInfo: boolean;
};

const FlexibleInfoContext = createContext<FlexibleInfoCtx>({
  showInfo: false,
});

export default FlexibleInfoContext;
